/* wildman.js - the concept shop.js, plus the two behaviours the shop needs and
   a static page did not.
   Source: concepts/shop/templates/shop.js  (everything above the quantity
   steppers is that file, unchanged)
   Scroll reveals (with a 1.5s failsafe and a prefers-reduced-motion opt-out),
   the product gallery swap, the home page header going solid past the hero, and
   the marquee pause control. Sections must not add reveal mechanics of their
   own - add the concept class .rise and let this file drive it.
   Added here: the quantity steppers, the sort selects and the mobile nav
   toggle. All three are progressive enhancement over markup the sections
   already ship. */
/* Wildman shop — gallery swap and scroll reveals.
   ?static (or #static) and reduced-motion turn motion off; a 1.5s safety net
   reveals everything regardless so nothing can be captured invisible. */
(function () {
  'use strict';
  var root = document.documentElement;
  var wantsStatic =
    /[?&#]static/.test(location.search + location.hash) ||
    (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var els = document.querySelectorAll('.rise');
  function revealAll(){ for (var i=0;i<els.length;i++) els[i].classList.add('in'); }

  if (wantsStatic || !('IntersectionObserver' in window)) {
    root.classList.add('static'); revealAll();
  } else if (els.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    for (var j=0;j<els.length;j++) io.observe(els[j]);
    setTimeout(function () { io.disconnect(); revealAll(); }, 1500);
  }

  /* gallery: crossfade the stage image when a thumbnail is chosen */
  var stage = document.querySelector('.stage');
  var main  = document.querySelector('.stage__bottle');
  var thumbs = document.querySelectorAll('.gal__thumbs button');
  if (stage && main && thumbs.length) {
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.dataset.full, alt = b.dataset.alt || '';
        if (!src || src === main.getAttribute('src')) return;
        thumbs.forEach(function (o) { o.setAttribute('aria-current', o === b ? 'true' : 'false'); });
        if (wantsStatic) { main.src = src; main.alt = alt; return; }
        stage.classList.add('is-swapping');
        var pre = new Image();
        pre.onload = function () {
          main.src = src; main.alt = alt;
          requestAnimationFrame(function () { stage.classList.remove('is-swapping'); });
        };
        pre.onerror = function () { stage.classList.remove('is-swapping'); };
        pre.src = src;
      });
    });
  }
})();

/* ---- home: header goes solid once the hero is behind you ---- */
(function () {
  'use strict';
  var hdr = document.querySelector('.hdr--over');
  var hero = document.querySelector('.hero');
  if (!hdr || !hero) return;

  if ('IntersectionObserver' in window) {
    /* trip the moment the hero's last 90px passes under the header */
    new IntersectionObserver(function (es) {
      hdr.classList.toggle('is-stuck', !es[0].isIntersecting);
    }, { rootMargin: '-90px 0px 0px 0px', threshold: 0 }).observe(hero);
  } else {
    hdr.classList.add('is-stuck');
  }
})();

/* ---- marquee: pause control, required for anything that
        auto-moves for more than five seconds (WCAG 2.2 §2.2.2) ---- */
(function () {
  'use strict';
  var track = document.querySelector('.marq__track');
  var btn = document.querySelector('.marq__pause');
  if (!track || !btn) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var paused = reduced;
  function apply() {
    track.dataset.paused = paused ? 'true' : 'false';
    btn.textContent = paused ? '▶' : '‖';
    btn.setAttribute('aria-label', paused ? 'Resume the scrolling banner' : 'Pause the scrolling banner');
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
  }
  btn.addEventListener('click', function () { paused = !paused; apply(); });
  apply();
})();

/* ---- quantity steppers ----
   The concept draws the minus and plus buttons; here they work. Pure
   progressive enhancement over the markup the sections already ship - a .qty
   box holding a button, an input[type=number] and a button - so nothing in the
   Liquid changes. Whichever button sits before the input reduces and the one
   after increases, the value is clamped to the input's own min (never below 1)
   and its max where it has one, and an input event is fired so anything
   listening for the quantity hears it. Covers the product buy area and every
   cart line, present and future. */
(function () {
  'use strict';

  function step(input, delta) {
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min) || min < 1) min = 1;
    var max = parseInt(input.getAttribute('max'), 10);
    var now = parseInt(input.value, 10);
    if (isNaN(now)) now = min;

    var next = now + delta;
    if (next < min) next = min;
    if (!isNaN(max) && next > max) next = max;
    if (next === now) return;

    input.value = next;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  var boxes = document.querySelectorAll('.qty');
  for (var i = 0; i < boxes.length; i++) {
    (function (box) {
      var input = box.querySelector('input[type="number"]');
      if (!input) return;
      var btns = box.querySelectorAll('button');
      for (var j = 0; j < btns.length; j++) {
        (function (btn) {
          /* DOCUMENT_POSITION_FOLLOWING: the input comes after this button,
             so this is the minus. */
          var delta = (btn.compareDocumentPosition(input) & 4) ? -1 : 1;
          btn.addEventListener('click', function (e) { e.preventDefault(); step(input, delta); });
        })(btns[j]);
      }
    })(boxes[i]);
  }
})();

/* ---- sort selects ----
   The concept's dropdowns are decorative; these navigate. On change the
   current URL is rebuilt with sort_by= and followed as a GET, so everything
   already in the query string survives - the search term q and its type, a
   collection's tag path - and the server does the sorting. On load the control
   is set to whatever sort_by the URL carries, so it shows the truth rather
   than always reading Featured. Markup untouched: the sections only name the
   select and give its options values. */
(function () {
  'use strict';
  var selects = document.querySelectorAll('select.sort[name="sort_by"]');
  for (var i = 0; i < selects.length; i++) {
    (function (sel) {
      var current = new URL(window.location.href).searchParams.get('sort_by');
      if (current) {
        for (var j = 0; j < sel.options.length; j++) {
          if (sel.options[j].value === current) { sel.selectedIndex = j; break; }
        }
      }
      sel.addEventListener('change', function () {
        var next = new URL(window.location.href);
        next.searchParams.set('sort_by', sel.value);
        window.location.assign(next.pathname + next.search);
      });
    })(selects[i]);
  }
})();

/* ---- mobile nav: the split-flap MENU toggle ----
   New design (MOBILE-NAV.md, requested 31-08-2026). At and under 900px the
   header's <nav> becomes a drop-down panel; this flips one class on the header
   and keeps aria-expanded honest. Everything visible - the letters turning, the
   stagger, the panel's drop and its overshoot - is CSS on that class, so no
   timer here has to agree with a duration in the stylesheet.

   The panel is a disclosure, not a dialog: no focus trap, no scroll lock, no
   inert background. Escape hands focus back to the button because the button
   is where the user was; a link click needs no such courtesy, the page is
   leaving. wm-header.liquid sets html.wm-js inline, so if this file never runs
   the CSS leaves the panel open and static rather than sealed shut. */
(function () {
  'use strict';
  var toggle = document.getElementById('wm-nav-toggle');
  var nav = document.getElementById('wm-nav');
  if (!toggle || !nav || !toggle.closest) return;
  var hdr = toggle.closest('.hdr');
  if (!hdr) return;

  function isOpen() { return hdr.classList.contains('is-navopen'); }

  function setOpen(open) {
    if (open === isOpen()) return;
    hdr.classList.toggle('is-navopen', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  toggle.addEventListener('click', function () { setOpen(!isOpen()); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (!isOpen()) return;
    setOpen(false);
    toggle.focus();
  });

  /* close on the way out, so a back-navigation from the browser cache does not
     restore the page with the panel hanging open under a MENU that reads CLOSE */
  nav.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('a')) setOpen(false);
  });

  /* a click or tap anywhere outside the header closes the panel */
  document.addEventListener('click', function (e) {
    if (!isOpen()) return;
    if (e.target && e.target.closest && e.target.closest('.hdr')) return;
    setOpen(false);
  });

  /* above the breakpoint the same element is the desktop nav again - it must
     never be left flagged open behind it */
  if (window.matchMedia) {
    var mq = window.matchMedia('(max-width: 900px)');
    var onChange = function () { if (!mq.matches) setOpen(false); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }
})();

/* Two-scene hero: pHure's world holds, an acid Jackdaw hops across as the
   herald, then the scene dissolves to Jackdaw's acid panel and back. The
   copy layer never moves. Honour reduced motion (no cycle, no hopper), the
   ?scene= and ?bird debug hooks (also used for static verification and the
   Figma path), pause while hovered or the tab is hidden, and hand control
   to the dots the moment a human uses them. */
(function () {
  var hero = document.querySelector('.hero[data-scene]');
  if (!hero) return;
  var hopper = hero.querySelector('.hero__hopper');
  var dots = [].slice.call(hero.querySelectorAll('.hero__dot'));
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var params = new URLSearchParams(window.location.search);

  var overHdr = document.querySelector('.hdr--over');
  function setScene(s) {
    hero.setAttribute('data-scene', s);
    if (overHdr) overHdr.classList.toggle('hdr--acid', s === 'jackdaw');
    dots.forEach(function (d) {
      d.setAttribute('aria-current', d.getAttribute('data-go') === s ? 'true' : 'false');
    });
  }
  dots.forEach(function (d) {
    d.addEventListener('click', function () {
      stopCycle();
      setScene(d.getAttribute('data-go'));
    });
  });

  if (params.get('scene')) setScene(params.get('scene'));
  if (params.has('bird') && hopper) hopper.classList.add('is-held');
  if (reduced || params.has('static') || params.get('scene') || params.has('bird')) return;

  var timer = null, stopped = false;
  function stopCycle() { stopped = true; clearTimeout(timer); }
  function hop(done) {
    if (!hopper) { done(); return; }
    hopper.classList.remove('is-hopping');
    void hopper.offsetWidth;
    hopper.classList.add('is-hopping');
    timer = setTimeout(done, 2400);
  }
  function wait(ms, done) { timer = setTimeout(done, ms); }
  function tick() {
    if (stopped) return;
    if (hero.matches(':hover') || document.hidden) { wait(2000, tick); return; }
    if (hero.getAttribute('data-scene') === 'phure') {
      hop(function () { if (!stopped) { setScene('jackdaw'); wait(8000, tick); } });
    } else {
      setScene('phure');
      wait(4000, tick);
    }
  }
  wait(4000, tick);
})();

/* ============================================================
   SIZE PICKER — the radios post the chosen variant natively;
   this only keeps the displayed figures in step with the choice.
   A variant priced at zero is not priced yet: its figure hides
   and the Coming soon state carries the message.
   ============================================================ */
(function () {
  var sizes = document.querySelector('[data-wm-sizes]');
  var dataEl = document.querySelector('script[data-wm-variants]');
  if (!sizes || !dataEl) return;

  var variants = {};
  try {
    JSON.parse(dataEl.textContent).forEach(function (v) { variants[String(v.id)] = v; });
  } catch (e) { return; }

  var price = document.querySelector('[data-wm-price]');
  var unit = document.querySelector('[data-wm-unit]');
  var stock = document.querySelector('[data-wm-stock]');
  var buy = document.querySelector('[data-wm-buy]');
  var sticky = document.querySelector('[data-wm-sticky]');
  var stickyBuy = document.querySelector('[data-wm-sticky-buy]');
  var cap = document.querySelector('[data-wm-cap]');
  var skuCell = document.querySelector('[data-wm-sku]');

  function money(pence) { return '£' + (pence / 100).toFixed(2); }

  function apply(v) {
    if (!v) return;
    var priced = v.price > 0;
    if (price) {
      price.textContent = money(v.price);
      price.hidden = !priced;
    }
    if (unit) {
      var abv = unit.getAttribute('data-abv') || '';
      unit.textContent = abv ? v.title + '  ·  ' + abv : v.title;
    }
    if (stock) {
      stock.classList.toggle('instock--soon', !v.available);
      stock.innerHTML = '<i></i>' + (v.available ? 'In stock' : 'Coming soon');
    }
    if (buy) {
      buy.disabled = !v.available;
      buy.innerHTML = v.available
        ? 'Add to bag  —  ' + money(v.price)
        : 'Coming soon';
    }
    if (sticky) {
      var t = sticky.getAttribute('data-title') || '';
      sticky.textContent = priced ? t + '  ' + money(v.price) : t;
    }
    if (stickyBuy) {
      stickyBuy.disabled = !v.available;
      stickyBuy.textContent = v.available ? 'Add to bag' : 'Coming soon';
    }
    if (v.sku) {
      if (cap) cap.textContent = v.sku + ' · ' + v.title.toUpperCase();
      if (skuCell) skuCell.textContent = v.sku;
    }
  }

  sizes.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') apply(variants[e.target.value]);
  });

  var checked = sizes.querySelector('input[name="id"]:checked');
  if (checked) apply(variants[checked.value]);
})();
